import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reporting-popup',
  templateUrl: './reporting-popup.component.html',
  styleUrls: ['./reporting-popup.component.scss']
})
export class ReportingPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
